import { jsx, jsxs } from 'react/jsx-runtime';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var close = /*#__PURE__*/jsx("svg", {
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  role: "img",
  children: /*#__PURE__*/jsx("path", {
    fill: "#000",
    d: "M7.05025 5.63603L11.9991 10.5851L16.9497 5.63603C17.3403 5.24551 17.9734 5.24551 18.364 5.63603C18.7545 6.02656 18.7545 6.65972 18.364 7.05025L13.4141 11.9991L18.364 16.9497C18.7545 17.3403 18.7545 17.9734 18.364 18.364C17.9734 18.7545 17.3403 18.7545 16.9497 18.364L11.9991 13.4141L7.05025 18.364C6.65972 18.7545 6.02656 18.7545 5.63603 18.364C5.24551 17.9734 5.24551 17.3403 5.63603 16.9497L10.5851 11.9991L5.63603 7.05025C5.24551 6.65972 5.24551 6.02656 5.63603 5.63603C6.02656 5.24551 6.65972 5.24551 7.05025 5.63603Z"
  })
});

var search = /*#__PURE__*/jsx("svg", {
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  role: "img",
  children: /*#__PURE__*/jsx("path", {
    fill: "#000",
    d: "M10.3797 2C15.5599 2 19.7593 6.11659 19.7593 11.1947C19.7593 12.7491 19.3658 14.2134 18.6712 15.4972L22.3176 19.0717C23.2153 19.9517 23.2297 21.3927 22.3497 22.2904L22.3176 22.3225C21.3966 23.2254 19.9224 23.2254 19.0014 22.3225L15.506 18.8958C14.0326 19.8403 12.2715 20.3893 10.3797 20.3893C5.19942 20.3893 1 16.2727 1 11.1947C1 6.11659 5.19942 2 10.3797 2ZM10.3797 4.29867C6.49448 4.29867 3.34492 7.38611 3.34492 11.1947C3.34492 15.0032 6.49448 18.0907 10.3797 18.0907C14.2649 18.0907 17.4144 15.0032 17.4144 11.1947C17.4144 7.38611 14.2649 4.29867 10.3797 4.29867Z"
  })
});

var preview = /*#__PURE__*/jsx("svg", {
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  role: "img",
  children: /*#__PURE__*/jsx("g", {
    children: /*#__PURE__*/jsx("path", {
      d: "M12 8.05556C11.5952 8.06189 11.1934 8.1262 10.8068 8.24653C10.9856 8.561 11.0808 8.91605 11.0833 9.27779C11.0833 9.55867 11.028 9.8368 10.9205 10.0963C10.813 10.3558 10.6555 10.5916 10.4569 10.7902C10.2583 10.9888 10.0225 11.1464 9.76296 11.2539C9.50346 11.3614 9.22532 11.4167 8.94444 11.4167C8.5827 11.4142 8.22765 11.319 7.91319 11.1402C7.66509 12.0006 7.694 12.9173 7.99584 13.7604C8.29768 14.6035 8.85713 15.3302 9.59496 15.8377C10.3328 16.3452 11.2116 16.6077 12.1069 16.5879C13.0021 16.5682 13.8685 16.2673 14.5833 15.7278C15.298 15.1883 15.8249 14.4376 16.0894 13.5821C16.3538 12.7265 16.3423 11.8094 16.0565 10.9607C15.7708 10.1121 15.2252 9.3748 14.4972 8.85339C13.7691 8.33198 12.8955 8.05286 12 8.05556ZM22.8671 11.7757C20.7958 7.73435 16.6953 5 12 5C7.30475 5 3.20304 7.73626 1.1329 11.7761C1.04552 11.9489 1 12.1399 1 12.3335C1 12.5272 1.04552 12.7182 1.1329 12.891C3.20418 16.9324 7.30475 19.6667 12 19.6667C16.6953 19.6667 20.797 16.9304 22.8671 12.8906C22.9545 12.7178 23 12.5268 23 12.3332C23 12.1395 22.9545 11.9485 22.8671 11.7757ZM12 17.8334C8.23211 17.8334 4.7778 15.7327 2.91238 12.3333C4.7778 8.93404 8.23173 6.83334 12 6.83334C15.7683 6.83334 19.2222 8.93404 21.0876 12.3333C19.2226 15.7327 15.7683 17.8334 12 17.8334Z"
    })
  })
});

var noPreview = /*#__PURE__*/jsx("svg", {
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  role: "img",
  children: /*#__PURE__*/jsxs("g", {
    children: [/*#__PURE__*/jsx("path", {
      d: "M12 8.05556C11.5952 8.06189 11.1934 8.1262 10.8068 8.24653C10.9856 8.561 11.0808 8.91605 11.0833 9.27779C11.0833 9.55867 11.028 9.8368 10.9205 10.0963C10.813 10.3558 10.6555 10.5916 10.4569 10.7902C10.2583 10.9888 10.0225 11.1464 9.76296 11.2539C9.50346 11.3614 9.22532 11.4167 8.94444 11.4167C8.5827 11.4142 8.22765 11.319 7.91319 11.1402C7.66509 12.0006 7.694 12.9173 7.99584 13.7604C8.29768 14.6035 8.85713 15.3302 9.59496 15.8377C10.3328 16.3452 11.2116 16.6077 12.1069 16.5879C13.0021 16.5682 13.8685 16.2673 14.5833 15.7278C15.298 15.1883 15.8249 14.4376 16.0894 13.5821C16.3538 12.7265 16.3423 11.8094 16.0565 10.9607C15.7708 10.1121 15.2252 9.3748 14.4972 8.85339C13.7691 8.33198 12.8955 8.05286 12 8.05556ZM22.8671 11.7757C20.7958 7.73435 16.6953 5 12 5C7.30475 5 3.20304 7.73626 1.1329 11.7761C1.04552 11.9489 1 12.1399 1 12.3335C1 12.5272 1.04552 12.7182 1.1329 12.891C3.20418 16.9324 7.30475 19.6667 12 19.6667C16.6953 19.6667 20.797 16.9304 22.8671 12.8906C22.9545 12.7178 23 12.5268 23 12.3332C23 12.1395 22.9545 11.9485 22.8671 11.7757ZM12 17.8334C8.23211 17.8334 4.7778 15.7327 2.91238 12.3333C4.7778 8.93404 8.23173 6.83334 12 6.83334C15.7683 6.83334 19.2222 8.93404 21.0876 12.3333C19.2226 15.7327 15.7683 17.8334 12 17.8334Z"
    }), /*#__PURE__*/jsx("line", {
      fill: "none",
      stroke: "#000000",
      x1: "2.72166",
      y1: "21.48453",
      x2: "21.27834",
      y2: "3.13403"
    }), /*#__PURE__*/jsx("line", {
      fill: "none",
      stroke: "#ffffff",
      x1: "3.44331",
      y1: "22.10308",
      x2: "21.99999",
      y2: "3.75259"
    })]
  })
});

export { close as c, noPreview as n, preview as p, search as s };
